"use client"

import { cn } from "@/lib/utils"

interface HeatmapStripProps {
  /** Array of intensity values 0–100, one per time bucket */
  samples: number[]
  className?: string
}

/**
 * Renders a thin color strip representing script activity over time.
 * Color goes from dim indigo (quiet) → hot pink → bright orange (intense).
 */
export function HeatmapStrip({ samples, className }: HeatmapStripProps) {
  if (!samples || samples.length === 0) return null

  return (
    <div className={cn("flex h-1.5 w-full overflow-hidden rounded-b", className)}>
      {samples.map((v, i) => (
        <div
          key={i}
          className="flex-1 min-w-0"
          style={{ backgroundColor: intensityToColor(v) }}
        />
      ))}
    </div>
  )
}

function intensityToColor(v: number): string {
  if (v <= 0) return "transparent"
  // Hue: 260 (indigo) → 320 (pink) → 30 (orange) as v goes 0→100
  const hue = 260 - v * 2.3
  const sat = 60 + v * 0.4
  const light = 30 + v * 0.35
  return `hsl(${hue}, ${sat}%, ${light}%)`
}
